// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"263da710","412":"aaa82d25","652":"d4b6aecd","812":"7dd6aad6"}[chunkId] + ".chunk.js";
};